/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-05 10:49:02
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import RoleConfigApi from './api/roleConfigApi';

export namespace RoleOperateVOI {
    export interface PropsI {
        operate: string;
        role?: {id: number, name: string};

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        name: string;
    }
}

@Component
class RoleOperateModal extends Vue.Component<RoleOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Object,
    })
    role!: {id: number, name: string};

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: RoleOperateVOI.FormDataI = {
        name: '',
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await RoleConfigApi.add(this.formData.name);
                break;
            case EnumOperates.Update.getName():
                res = await RoleConfigApi.update(this.formData.id as number, this.formData.name);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    mounted() {
        if(this.operate === EnumOperates.Update.getName()) {
            this.formData = {...this.role}
        }
    }

    render(h) {
        return (
            <Modal title={this.operate+ '角色'} width="500" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData}>
                    <form-item label="名称" prop="name" required style="width:80%">
                        <Input v-model={this.formData.name} placeholder="请输入名称" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertRoleOperateModal(operate: string, role?: {id: number, name: number}): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<RoleOperateVOI.PropsI>(RoleOperateModal)({
            role,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
